import { ExternalIntegrationCard } from '../ExternalIntegrationCard/ExternalIntegrationCard'
import { ExternalIntegrationEnum, FacebookIntegration } from 'api/clients/ExternalIntegrationsClient'
import { Facebook } from 'almanac-ui/icons'
import { CardButtons } from './CardButtons'
import { useModals } from 'almanac-ui/Modal'
import { FacebookInitialization } from 'components/IntegrationInitialization'

export const FacebookCard = ({
  integrations = [],
  isDisconnected = false,
}: {
  integrations?: FacebookIntegration[]
  isDisconnected?: boolean
}) => {
  const { openModal } = useModals()

  return (
    <ExternalIntegrationCard
      title={'Facebook'}
      description={'Post directly to your Facebook account or business page'}
      integrations={integrations}
      icon={<Facebook size={20} />}
      isDisconnected={isDisconnected}
      buttons={
        <CardButtons
          onConnect={() => openModal(FacebookInitialization)}
          provider={ExternalIntegrationEnum.Facebook}
          isConnected={integrations.length > 0}
          integration={integrations[0]}
          isDisconnected={isDisconnected}
        />
      }
    />
  )
}
